import axios from './axios'

export interface Company {
  id: string
  name: string
  type?: string
  address?: {
    street: string
    city: string
    state: string
    zip: string
  }
  phone?: string
  email?: string
  website?: string
  logo?: string
  isActive?: boolean
  isSelected?: boolean
  nmls?: string
}

class CompaniesService {
  async getAllCompanies(params?: {
    page?: number
    limit?: number
    type?: string
  }) {
    const response = await axios.get('/companies', { 
      params,
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    return response.data
  }

  async getCompanyById(id: string) {
    const response = await axios.get(`/companies/${id}`, {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    return response.data
  }

  async getAssignedCompanies() {
    const response = await axios.get('/companies/assigned', {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    return response.data
  }

  async switchSelectedCompany(companyId: string | number) {
    const response = await axios.post('/companies/switch', {
      companyId: companyId
    }, {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    return response.data
  }
}

export default new CompaniesService() 
